import { useEffect, useState } from "react";

export function useLocalStorage<T>(
	key: string,
	initial: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
	const [value, setValue] = useState(() => {
		return ReadFromLocalStorage<T>(key, initial);
	});

	useEffect(() => {
		WriteToLocalStorage<T>(key, value);
	}, [key, value]);

	return [value, setValue];
}

export function WriteToLocalStorage<T>(key: string, value: T) {
	window.localStorage.setItem(key, JSON.stringify(value));
}

export function ReadFromLocalStorage<T>(key: string, initial: T) {
	if (typeof window !== "undefined") {
		const existing = window.localStorage.getItem(key);
		if (typeof existing !== "undefined" && existing !== null) {
			return JSON.parse(existing) as T;
		}
	}

	return initial;
}

export interface RouteParams extends Record<string, string> {
	id: string;
	groupId: string;
	hide: string;
	schemeId: string;
	tagid: string;
	userid: string;
	jobid: string;
	checklistid: string;
	redirectto: string;
	nodeEditSection: string;
	action: string;
	nodeid: string;
}
